export default "__VITE_ASSET__DpafibpI__"